import { onMounted } from "vue-demi";
import { checkRecaptchaLoad } from "../script-manager/common.mjs";
import { warn } from "../utils.mjs";
import { useRecaptchaContext } from "./context.mjs";
export function useRecaptchaProvider() {
  const ctx = useRecaptchaContext();
  if (ctx.scriptInjected) {
    warn("`useRecaptchaProvider` is used multiple time");
  } else {
    ctx.scriptInjected = true;
    ctx.useScriptProvider();
    onMounted(() => {
      checkRecaptchaLoad();
    });
  }
}
